import { useTheme } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { useContext, useCallback, createElement } from 'react';
import '../../utilities/get-styleprop.js';
import { a as _objectSpread2 } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import Button from '../../Button/Button.js';
import '../state/constants.js';
import { saveOneFilter } from '../state/actions.js';
import FilterPanelContext from '../FilterPanelContext.js';

const ApplyFilterButton = ({
  field,
  applyButtonLabel = 'Apply filter',
  styles = {}
}) => {
  const theme = useTheme();
  const {
    state,
    dispatch
  } = useContext(FilterPanelContext);
  const handleClick = useCallback(() => {
    dispatch(saveOneFilter(field));
  }, [field]);
  if (state.lastUpdatedElementId !== field) {
    return null;
  }
  return /*#__PURE__*/createElement(Button, {
    onClick: handleClick,
    styles: {
      root: _objectSpread2({
        ml: `${theme.spacing.xs}px`
      }, styles.root)
    },
    variant: "primary",
    small: true
  }, applyButtonLabel);
};

export default ApplyFilterButton;
